import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const SelectPermission = ({
  permissionNameLabel,
  permissionName,
  formikprops,
}) => (
  <span className="day-block">
    <Form.Check
      name={`${permissionName}`}
      id={`${permissionName}`}
      type="checkbox"
      label={`${
        permissionNameLabel.toLowerCase()[0].toUpperCase() +
        permissionNameLabel.toLowerCase().substring(1)
      }`}
      className="pt-2 pb-2"
      checked={
        formikprops.values.selectedPermissions.indexOf(permissionName) > -1
      }
      onChange={(e) => {
        const { id, checked } = e.target;
        if (!checked) {
          formikprops.setFieldValue(
            'selectedPermissions',
            formikprops.values.selectedPermissions.filter((day) => day !== id)
          );
        } else {
          formikprops.setFieldValue('selectedPermissions', [
            ...formikprops.values.selectedPermissions,
            id,
          ]);
        }
      }}
    />
  </span>
);
SelectPermission.propTypes = {
  permissionNameLabel: PropTypes.string,
  permissionName: PropTypes.string,
  formikprops: PropTypes.any,
};

export default SelectPermission;
